import React, { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, FormControlLabel, Switch } from '@mui/material';
import axios from 'axios';
import { addUser, listUser, updateUser } from '../api/api';
import { toast } from "react-toastify";

const rolesList = ["Admin", "User", "CUSTOMERSERVICE","CALLCENTER"];//user , customerservice pazarlama, callcenter müşteri hizmetleri

const UserManagement = () => {
  const [users, setUsers] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState({ userName: '', email: '', roles: [] });
  const [isUpdate, setIsUpdate] = useState(false);

  useEffect(() => {

    fetchUsers();
  }, []);


  const fetchUsers = async () => {
    listUser().then((response) => {
      // Her kullanıcıda roles alanı yoksa boş dizi olarak ekle
      const userList = (response.value || []).map(u => ({
        ...u,
        roles: u.roles || [],
        isActive: typeof u.isActive === 'boolean' ? u.isActive : true
      }));
      setUsers(userList);
    });
  }

  const handleOpen = (user = { userName: '', email: '', roles: [] }, update = false) => {
    setSelectedUser({ ...user, roles: user.roles || [], isActive: typeof user.isActive === 'boolean' ? user.isActive : true });
    setIsUpdate(update);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedUser({ userName: '', email: '', roles: [] });
  };

  const handleSave = () => {
    // roles alanı her zaman dizi olmalı
    const userToSend = { ...selectedUser, roles: selectedUser.roles || [] };
    if (!isUpdate) {
      addUser(userToSend).then((res) => {
        if (res.isSuccess) {
          toast.success("Kullanıcı Eklendi.");
          fetchUsers();
          handleClose();
        } else {
          toast.error("Kullanıcı eklenemedi. Hata: " + JSON.stringify(res.error));
        }
      });
    } else {
      updateUser(userToSend).then((res) => {
        if (res.isSuccess) {
          toast.success("Kullanıcı başarıyla güncellendi.");
          fetchUsers();
          handleClose();
        } else {
          toast.error("Kullanıcı güncellenemedi. Hata: " + JSON.stringify(res.error));
        }
      });
    }
  };

  // isActive toggle is handled in the add/update dialog only

  const columns = [
    { field: 'id', headerName: 'ID', width: 90, visible: false },
    { field: 'userName', headerName: 'Kullanıcı Adı', width: 200 },
    { field: 'email', headerName: 'Email', width: 220 },
    {
      field: 'isActive',
      headerName: 'Durum',
      width: 120,
      renderCell: (params) => (
        <span>{params.row.isActive ? <span style={{color:'green'}}>Aktif</span> : <span style={{color:'red'}}>Pasif</span>}</span>
      ),
    },
    {
      field: 'roles',
      headerName: 'Roller',
      width: 220,
      renderCell: (params) => (
        <span>{Array.isArray(params.row.roles) ? params.row.roles.join(", ") : ""}</span>
      ),
    },
    {
      field: 'actions',
      headerName: '',
      width: 150,
      renderCell: (params) => (
        <Button variant="contained" color="primary" onClick={() => handleOpen(params.row, true)}>
          Güncelle
        </Button>
      ),
    },
  ];

  return (
    <div>
      <Button variant="contained" color="primary" onClick={() => handleOpen()}>
        Yeni Kullanıcı Ekle
      </Button>
      <div style={{ height: 700, width: '100%', marginTop: 20 }}>
        <DataGrid   
    columnVisibilityModel={{
        // Hide columns status and traderName, the other columns will remain visible
        id: false,        
      }}
   rows={users} columns={columns} pageSize={25} />
      </div>

      <Dialog maxWidth={'md'} fullWidth={true} open={open} onClose={handleClose}>
        <DialogTitle>{isUpdate ? 'Kullanıcı Güncelle' : 'Yeni Kullanıcı Ekle'}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Kullanıcı Adı"
            fullWidth
            variant="outlined"
            value={selectedUser.userName}
            onChange={(e) => setSelectedUser({ ...selectedUser, userName: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Email"
            fullWidth
            variant="outlined"
            value={selectedUser.email}
            onChange={(e) => setSelectedUser({ ...selectedUser, email: e.target.value })}
          />
          {/* isActive kontrolü: sadece dialogda değiştirilebilir */}
          <div style={{ marginTop: 12 }}>
            <FormControlLabel
              control={
                <Switch
                  checked={!!selectedUser.isActive}
                  onChange={(e) => setSelectedUser({ ...selectedUser, isActive: e.target.checked })}
                  color="primary"
                />
              }
              label={selectedUser.isActive ? 'Aktif' : 'Pasif'}
            />
          </div>
          {/* Çoklu rol seçimi */}
          <div style={{ marginTop: 16, marginBottom: 8 }}>
            <label style={{ fontWeight: 500, marginBottom: 4, display: 'block' }}>Roller</label>
            <select
              multiple
              value={selectedUser.roles}
              onChange={e => {
                const options = Array.from(e.target.selectedOptions, option => option.value);
                setSelectedUser({ ...selectedUser, roles: options });
              }}
              style={{ width: '100%', minHeight: 80, padding: 8, borderRadius: 4, border: '1px solid #ccc' }}
            >
              {rolesList.map(role => (
                <option key={role} value={role}>{role}</option>
              ))}
            </select>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            İptal
          </Button>
          <Button onClick={handleSave} color="primary">
            Kaydet
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default UserManagement;
